export const courseNames = (state = [], action) => {
    switch (action.type) {
        case "SET_COURSE_NAMES":{
            return action.payload.courseNames;
        }
        default: {
            return state;
        }
    }
};